import { inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

/** @deprecated Use {@link Title} & {@link Meta} directly. */
@Injectable({ providedIn: 'root' })
export class SEOService {
  private readonly meta = inject(Meta);
  private readonly title = inject(Title);

  updateTitle(title: string) {
    this.title.setTitle(title);
  }

  updateOgUrl(url: string) {
    this.meta.updateTag({ name: 'og:url', content: url });
  }

  updateDescription(desc: string) {
    this.meta.updateTag({ name: 'description', content: desc });
  }
}
